import { render, staticRenderFns } from "./OdontogramaGerenciarServicosAtendimentoTabela.vue?vue&type=template&id=05cfe9cd&scoped=true"
import script from "./OdontogramaGerenciarServicosAtendimentoTabela.vue?vue&type=script&lang=js"
export * from "./OdontogramaGerenciarServicosAtendimentoTabela.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaGerenciarServicosAtendimentoTabela.vue?vue&type=style&index=0&id=05cfe9cd&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cfe9cd",
  null
  
)

export default component.exports